import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { Select } from '../../../../design/inputs/select/Select';
import { EnableFor } from '../../../containers/EnableForRole';
import { ImageAssignmentPolicy } from '../projectDetails.models';
import { useProjectDetailsPermissions } from '../projectDetails.permissions';

interface IProps {
  onPolicyChange(policy: ImageAssignmentPolicy): Promise<void>;
  selectedPolicy: ImageAssignmentPolicy;
}

export const ProjectImageAssignmentPolicyForm = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  const projectDetailsPermissions = useProjectDetailsPermissions();
  const canUpdateImageAssignmentPolicy = projectDetailsPermissions.canUpdateImageAssignmentPolicy();

  const options = [
    { value: ImageAssignmentPolicy.SEQUENTIAL, label: t('image_assignment_policy_sequential') },
    { value: ImageAssignmentPolicy.RANDOM, label: t('image_assignment_policy_random') },
    { value: ImageAssignmentPolicy.PARALLEL, label: t('image_assignment_policy_parallel') },
  ];

  return (
    <EnableFor hasPermission={canUpdateImageAssignmentPolicy}>
      <Select
        id='policy-dropdown'
        name='select'
        value={options.find((x) => x.value === props.selectedPolicy)}
        onChange={(_, v) => {
          void props.onPolicyChange(v.value ?? ImageAssignmentPolicy.RANDOM);
        }}
        options={options}
      />
    </EnableFor>
  );
});
